import React, { FC, useState } from "react";
import { ColorResult } from "react-color";
import useOnClickOutside from "use-onclickoutside";

import { Button } from "@/components/atoms/buttons/Button";
import { IsDesktop, IsMobile } from "@/components/atoms/mediaQuery/MediaQuery";
import CustomColorPicker from "@/components/editors/tools/CustomPicker";
import CustomColorPickerSP from "@/components/editors/tools/CustomPickerSP";
import { Modal } from "@/components/molecules/modals/Modal";

import CloseIcon from "/public/icon/close-colorpicker-modal.svg";

interface Props {
  color: string;
  onColorChangeHandler: (color: string) => void;
}

export const SetColorModal: FC<Props> = ({ color, onColorChangeHandler }) => {
  const [openPicker, setOpenPicker] = useState<boolean>(false);

  const ref = React.useRef(null);
  useOnClickOutside(ref, () => {
    if (ref.current) {
      setCurrentColor(color);
      setOpenPicker(false);
    }
  });

  const [currentColor, setCurrentColor] = useState<string>(color);

  // カラーピッカー ------
  const handleColorChange = (color: ColorResult) => {
    const colorCode = String(color.hex);
    setCurrentColor(colorCode);
  };
  // カラーピッカー ------

  const resetHandler = () => {
    setCurrentColor("FFFFFF");
  };

  const submitHandler = () => {
    onColorChangeHandler(currentColor);
    setOpenPicker(false);
  };

  return (
    <>
      <Button
        label="カラー選択"
        color="bg-white"
        size="sm-fix"
        spSize="sm-fix"
        onClick={() => setOpenPicker(!openPicker)}
        className="text-base"
      />
      <IsDesktop>
        <Modal isOpen={openPicker} handleClose={() => setOpenPicker(false)}>
          <div
            ref={ref}
            className="absolute -bottom-1 left-0 z-50 bg-white rounded translate-y-full"
          >
            <div className="p-4 pb-1">
              <CustomColorPicker
                color={currentColor}
                onChange={handleColorChange}
              />
            </div>
            <div className="flex justify-end p-4 pt-3 mt-4 space-x-2 border-t">
              <Button
                type="button"
                size="sm"
                color="primary-outline"
                onClick={resetHandler}
                label="リセット"
                className="px-0 w-[80px] whitespace-nowrap"
              />
              <Button
                type="submit"
                size="sm"
                color="primary"
                label="決定"
                onClick={submitHandler}
                className="px-0 w-[78px] whitespace-nowrap"
              />
            </div>
          </div>
        </Modal>
      </IsDesktop>
      <IsMobile>
        <Modal isOpen={openPicker} handleClose={() => setOpenPicker(false)}>
          <div ref={ref}>
            <button
              type="button"
              className="absolute -top-10 -right-2 p-2"
              onClick={() => setOpenPicker(false)}
            >
              <CloseIcon
                width={25}
                height={24}
                title="カラーピッカーを閉じる"
              />
            </button>
            <div className="p-4 pb-1">
              <CustomColorPickerSP
                color={currentColor}
                onChange={handleColorChange}
              />
            </div>
            <div className="grid grid-cols-2 gap-x-2 p-4 mt-4 border-t border-theme-light">
              <Button
                type="button"
                size="lg-fix"
                color="primary-outline"
                onClick={resetHandler}
                label="リセット"
              />
              <Button
                type="submit"
                size="lg-fix"
                color="primary"
                label="決定"
                onClick={submitHandler}
              />
            </div>
          </div>
        </Modal>
      </IsMobile>
    </>
  );
};
